var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _c(
      "nav",
      { staticClass: "navbar navbar-dark bg-dark justify-content-between" },
      [
        _c("div", { staticClass: "container" }, [
          _c(
            "a",
            {
              staticClass: "navbar-brand",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.goToDashboard()
                }
              }
            },
            [
              _c("img", {
                staticClass: "d-inline-block align-top",
                attrs: {
                  src: require("@/assets/images/logo.svg"),
                  height: "30",
                  alt: ""
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "btn-group profile-button",
                style: { opacity: _vm.profileLoading ? 0 : 1 }
              },
              [
                _c(
                  "button",
                  { staticClass: "btn", attrs: { type: "button" } },
                  [
                    _c("img", {
                      staticClass: "profile-icon",
                      attrs: {
                        src: require("@/assets/images/default_profile_icon.jpg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "mobile" }, [
                      _vm._v(_vm._s(_vm.name))
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41458b80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41458b80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = null
// module chunks = 